import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import './IkeaOrdersList.css';
import { Container, TableFooter } from '@mui/material';
import { ikeaImageSrc } from '../../utils/ikeaImage';

const IkeaOrdersList = ({ data }) => {
    console.log(data);
    return (
        <Container maxWidth="lg" className="mt-20">
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Order #</TableCell>
                            <TableCell>Order Date</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>SKUs</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row) => (
                            <TableRow
                                key={row._id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                className="creditnotes-row"
                            >
                                <TableCell component="th" scope="row">
                                    {row.orderNumber}
                                </TableCell>
                                <TableCell>{new Intl.DateTimeFormat("en-GB", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(row.date))}</TableCell>
                                <TableCell component="th" scope="row">{row.name}</TableCell>
                                <TableCell className="sku-cell">
                                    {row.cart.map((item, itemIndex) => (
                                        <div key={itemIndex} className="sku-container">
                                            <div className="item-name">{item.name} ({item.amount}x)</div>
                                            <div className="sku-details">
                                                {item.dimensions.map((dimension, dimIndex) => (
                                                    <div key={dimIndex} className="dimension-wrapper">
                                                        {dimension.image ? (
                                                            <img
                                                                src={ikeaImageSrc(dimension.image)}
                                                                alt={(dimension.imageAlt && String(dimension.imageAlt)) || dimension.sku || ''}
                                                                className="dimension-component-thumb"
                                                                loading="lazy"
                                                            />
                                                        ) : null}
                                                        <span className="main-sku">SKU: {dimension.sku}{' '}                                                             {dimension.packages.map((pkg, pkgIndex) => (
                                                                <span key={pkgIndex} className="package-item">
                                                                    {pkg.articleNumber || dimension.sku} ({pkg.packages}x){pkgIndex < dimension.packages.length - 1 ? ', ' : ''}
                                                                </span>
                                                            ))}</span>
                                                    </div>
                                                ))}
                                            </div>
                                            {itemIndex < row.cart.length - 1 && (
                                                <hr className="item-divider" />
                                            )}
                                        </div>
                                    ))}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    {/* <TableFooter>
                        <TableRow>
                            <TableCell>Total</TableCell>
                            <TableCell></TableCell>
                            <TableCell component="th" scope="row">{credit && '-'}€{totals.netTotal.toFixed(2)}</TableCell>
                            <TableCell component="th" scope="row">{credit && '-'}€{totals.shippingTotal.toFixed(2)}</TableCell>
                            <TableCell component="th" scope="row">{credit && '-'}€{totals.surchargeTotal.toFixed(2)}</TableCell>
                            <TableCell component="th" scope="row">{credit && '-'}€{totals.vatTotal.toFixed(2)}</TableCell>
                            <TableCell component="th" scope="row">{credit && '-'}€{totals.grossTotal.toFixed(2)}</TableCell>
                        </TableRow>
                    </TableFooter> */}
                </Table>
            </TableContainer>
        </Container>
    );
};

export default IkeaOrdersList